import { RouterProvider } from 'react-router-dom';

import { Skeleton } from '~/shared/ui/skeleton';

import { router } from '../router';

export function AppRouterProvider() {
  return (
    <RouterProvider
      router={router}
      fallbackElement={<Skeleton type="page" />}
    />
  );
}
